module.exports = __webpack_public_path__ + "img/9.af329580.jpg";